import {useCallback, useRef} from 'react'
import {useLocation, resolvePath as reactRouterResolvePath} from '@github-ui/react-router'
import {useNavigate} from '@github-ui/use-navigate'

export const useRelativeNavigation = () => {
  const {pathname, search} = useLocation()
  const paramsRef = useRef(new URLSearchParams(search))
  const reactRouterNavigate = useNavigate()

  const navigate = useCallback(
    (pathPartial: string, _search?: string, clearExistingParams = true, replace = false) => {
      if (clearExistingParams) {
        paramsRef.current = new URLSearchParams()
      }
      if (_search) {
        const additionalParams = new URLSearchParams(_search)
        for (const [key, value] of additionalParams) {
          if (value === '') {
            paramsRef.current.delete(key)
          } else {
            paramsRef.current.set(key, value)
          }
        }
      }
      return reactRouterNavigate(
        reactRouterResolvePath({pathname: pathPartial, search: paramsRef.current.toString()}, pathname),
        {
          replace,
        },
      )
    },
    [reactRouterNavigate, pathname],
  )

  const resolvePath = useCallback(
    (pathPartial: string) => reactRouterResolvePath({pathname: pathPartial}, pathname).pathname,
    [pathname],
  )

  return {
    pathname,
    search,
    navigate,
    resolvePath,
  }
}
